import { render, staticRenderFns } from "./PremiumBanner.vue?vue&type=template&id=0f2e0417&scoped=true&"
import script from "./PremiumBanner.vue?vue&type=script&lang=js&"
export * from "./PremiumBanner.vue?vue&type=script&lang=js&"
import style0 from "./PremiumBanner.vue?vue&type=style&index=0&id=0f2e0417&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2e0417",
  null
  
)

export default component.exports